interface ClarifyingBubbleProps {
  question: string;
  options: string[];
  onSelect: (option: string) => void;
  selectedIndex?: number;
}

export function ClarifyingBubble({ question, options, onSelect, selectedIndex }: ClarifyingBubbleProps) {
  return (
    <div
      className="flex flex-col gap-3 p-4 rounded-sm"
      style={{
        border: '2px solid var(--accent-amber, #e8b000)',
        backgroundColor: 'var(--surface-container-high)',
      }}
    >
      <div className="flex items-start gap-2">
        <span
          className="material-symbols-outlined text-[18px] shrink-0 mt-0.5"
          style={{ color: 'var(--accent-amber, #e8b000)' }}
        >
          help_outline
        </span>
        <p className="text-[15px]" style={{ color: 'var(--text-primary)' }}>
          {question}
        </p>
      </div>

      {options.length > 0 && (
        <div className="flex flex-wrap gap-2 pl-7">
          {options.map((opt, i) => (
            <button
              key={opt}
              type="button"
              onClick={() => onSelect(opt)}
              className="px-3 py-1.5 rounded-sm text-xs font-semibold transition-colors"
              style={{
                border: '1px solid var(--outline-variant)',
                backgroundColor: selectedIndex === i ? 'var(--surface-container-highest)' : 'var(--surface-container)',
                color: selectedIndex === i ? '#0078d4' : 'var(--text-primary)',
              }}
              onMouseEnter={e => {
                (e.currentTarget as HTMLButtonElement).style.backgroundColor = 'var(--surface-container-highest)';
              }}
              onMouseLeave={e => {
                (e.currentTarget as HTMLButtonElement).style.backgroundColor =
                  selectedIndex === i ? 'var(--surface-container-highest)' : 'var(--surface-container)';
              }}
            >
              {opt}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
